export default __webpack_public_path__ + "locales/sq-AL/Common.json?hash=11f73aab4f3c0202de3bd67538b290de";